import React, { useContext, useCallback, useState } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import { useTranslator } from '@jutro/locale';
import { useModal } from '@jutro/components';

import AddressComponent from "premier-capability-policyjob-react/components/AddressComponent/AddressComponent";
import metadata from './InformationComponent.metadata.json5';
import styles from '../../SpaAndWellnessStyles.module.scss';
import messages from './InformationComponent.messages';
import CoveragesPageComponent from "../../pages/Coverages/CoveragesPage";
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function InformationComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated, viewModelService } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('InformationComponent');
    const modelVM = _.get(submissionVM, pathUpdated)
    const { showConfirm } = useModal();
    const [isEditAddress, setIsEditAddress] = useState(false)
    const [actAddress, setActAddress] = useState(null)
    const translator = useTranslator();
    const heaWelFitFac = 'HeaWelFitFac'
    const beaSpaWel = 'BeaSpaWel'

    modelVM.isValidationReq.value = true

    if (_.isUndefined(modelVM.accountLocFie.value)) {
        const model = { country: 'CA' }
        const { _xCenter, _dtoName } = modelVM.accountLocFie;
        const addressDetailsVM = viewModelService.create(model, _xCenter, _dtoName);

        _.set(modelVM, 'accountLocFie.value', addressDetailsVM.value)
    }

    const setIsEditButton = () => {
        setActAddress(modelVM.accountLocFie.value)
        setIsEditAddress(true)
    }

    const setIsCancelButton = () => {
        const model = actAddress
        const { _xCenter, _dtoName } = modelVM.accountLocFie;
        const addressDetailsVM = viewModelService.create(model, _xCenter, _dtoName);

        _.set(modelVM, 'accountLocFie.value', addressDetailsVM.value)
        setIsEditAddress(false)
    }

    const setIsSaveButton = () => {
        setIsEditAddress(false)
    }

    const getAddressOptions = () => {
        const availableValues = submissionVM.value.baseData.account_Ext.accountLocations_Ext.map((actLct) => ({
            code: actLct.publicID,
            name: actLct.displayName
        }));

        return availableValues.concat({
            code: 'new',
            name: '-- Add New --'
        })
    };

    const fillAddressDetails = (value, changedPath) => {
        handleValueChange(value, changedPath)

        if (value === 'new') {
            const model = { country: 'CA', publicID: value }
            const { _xCenter, _dtoName } = modelVM.accountLocFie;
            const addressDetailsVM = viewModelService.create(model, _xCenter, _dtoName);

            _.set(modelVM, 'accountLocFie.value', addressDetailsVM.value)
        } else {

            modelVM.accountLocFie.value = _.find(submissionVM.value.baseData.account_Ext.accountLocations_Ext, (actLct) => actLct.publicID === value);
        }

        handleValueChange(modelVM.accountLocFie.value, 'accountLocFie')
    };   

    const handleValueChange = useCallback(
        (value, changedPath) => {
            let fullPath = `${pathUpdated}.${changedPath}`;

            if (value === 'new' && changedPath === 'actAdrsPublicID') {
                setIsEditAddress(true)
            }

            if (changedPath === 'neighbouringAcc' || changedPath === 'neighbouring') {
                fullPath = `${pathUpdated}.${changedPath}.value`;

                if (_.isUndefined(_.get(submissionVM, `${fullPath}`))) {
                    _.set(submissionVM, `${fullPath}`, []);
                }

                _.set(submissionVM, `${fullPath}`, value);
            } else if (changedPath === 'yeaBuiFie') {
                _.set(submissionVM, `${fullPath}`, value);

                _.set(submissionVM, `${pathUpdated}.rooDatlasupdFie`, value);
                _.set(submissionVM, `${pathUpdated}.eleYealasupdFie`, value);
                _.set(submissionVM, `${pathUpdated}.heaYealasupdFie`, value);
                _.set(submissionVM, `${pathUpdated}.pluYeaLasUpdFie`, value);
            } else {
                _.set(submissionVM, `${fullPath}`, value);
            }

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    const onAddressChange = useCallback((value, changedPath) => {
        const fullPath = `${pathUpdated}.accountLocFie.${changedPath}`;

        _.set(submissionVM, `${fullPath}`, value);
        updateWizardData(submissionVM);
    }, [pathUpdated, submissionVM, updateWizardData]);

    const getFirProDistoFirDepFieAvailableValues = useCallback(() => {
        if (submissionVM.lobData.spaAndWellLine.value.selectedOffering_Ext === heaWelFitFac) {
            return _.filter(
                modelVM.firProDistoFirDepFie.aspects.availableValues,
                (filteredValue) => filteredValue.code !== 'Bet5m' && filteredValue.code !== 'With5m'
            ).map((firPro) => ({
                code: firPro.code,
                name: translator({
                    id: firPro.name,
                    defaultMessage: firPro.name
                })
            }))
        }

        return modelVM.firProDistoFirDepFie.aspects.availableValues.map((firPro) => ({
            code: firPro.code,
            name: translator({
                id: firPro.name,
                defaultMessage: firPro.name
            })
        }))
    }, [modelVM, submissionVM, translator])

    const getEleSysFieAvailableValues = useCallback(() => {
        if (submissionVM.lobData.spaAndWellLine.value.selectedOffering_Ext === heaWelFitFac) {
            return _.filter(
                modelVM.eleSysFie.aspects.availableValues,
                (filteredValue) => filteredValue.code !== 'CirBui'
            ).map((eleSys) => ({
                code: eleSys.code,
                name: translator({
                    id: eleSys.name,
                    defaultMessage: eleSys.name
                })
            }))
        } else if (submissionVM.lobData.spaAndWellLine.value.selectedOffering_Ext === beaSpaWel) {
            return _.filter(
                modelVM.eleSysFie.aspects.availableValues,
                (filteredValue) => filteredValue.code !== '10Amp'
            ).map((eleSys) => ({
                code: eleSys.code,
                name: translator({
                    id: eleSys.name,
                    defaultMessage: eleSys.name
                })
            }))
        }

        return modelVM.eleSysFie.aspects.availableValues.map((eleSys) => ({
            code: eleSys.code,
            name: translator({
                id: eleSys.name,
                defaultMessage: eleSys.name
            })
        }))
    }, [modelVM, submissionVM, translator])

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        actAdrsPublicID: {
            availableValues: getAddressOptions(),
            onValueChange: fillAddressDetails
        },
        locRiskddressComponent: {
            labelPosition: 'left',
            value: modelVM.accountLocFie,
            viewModelService,
            readOnly: isEditAddress ? [] : ['addressLine1Field', 'addressLine2Field', 'addressLine3Field', 'addressCity', 'addressState', 'addressPostalCode'],
            hideFields: ['addressDescription', 'addressType', 'addressCountry', 'addressCounty'],
            requiredFields: ['addressLine1Field', 'postalCode'],
            onValueChange: onAddressChange
        },
        editAddressButton: {
            visible: modelVM.actAdrsPublicID.value !== 'new' && !isEditAddress
        },
        saveAddressButton: {
            visible: modelVM.actAdrsPublicID.value === 'new' || isEditAddress
        },
        cancelAddressButton: {
            visible: modelVM.actAdrsPublicID.value !== 'new' && isEditAddress
        },
        ifOthExpFie4: {
            visible: !_.isUndefined(modelVM.value.othFie) && modelVM.value.othFie
        },
        ifOthExpFie1: {
            visible: !_.isUndefined(modelVM.value.conFie) && modelVM.value.conFie === "Oth"
        },
        ifOthExpFie2: {
            visible: !_.isUndefined(modelVM.value.heaFie) && modelVM.value.heaFie === "Other"
        },
        ifOthExpFie: {
            visible: !_.isUndefined(modelVM.value.eleSysFie) && modelVM.value.eleSysFie === "Oth"
        },
        doyouownthebuiFie: {
            defaultValue: false
        },
        surSysFie: {
            defaultValue: false
        },
        doohavdeaFie: {
            defaultValue: false
        },
        baronDooFie: {
            defaultValue: false
        },
        anySmoonPreFie: {
            defaultValue: false
        },
        burAlaFie: {
            defaultValue: false
        },
        monFie: {
            defaultValue: false
        },
        sprFie: {
            defaultValue: false
        },
        firProDistoFirDepFie: {
            availableValues: getFirProDistoFirDepFieAvailableValues(),
            defaultValue: _.get(submissionVM, 'lobData.spaAndWellLine.selectedOffering_Ext.value') === 'BeaSpaWel' ? 'With5m' : 'With8Km'
        },
        numFirExtFie: {
            visible: submissionVM.lobData.spaAndWellLine.value.selectedOffering_Ext === heaWelFitFac,
            required: submissionVM.lobData.spaAndWellLine.value.selectedOffering_Ext === heaWelFitFac,
            defaultValue: 0
        },
        firAlaFie: {
            visible: submissionVM.lobData.spaAndWellLine.value.selectedOffering_Ext === heaWelFitFac,
            required: submissionVM.lobData.spaAndWellLine.value.selectedOffering_Ext === heaWelFitFac,
            defaultValue: 'Non'
        },
        eleSysFie: {
            availableValues: getEleSysFieAvailableValues()
        },
        numofStoFie: {
            defaultValue: 1
        },
        firProDistoFirHydFie: {
            defaultValue: 'Wh300m'
        },
        proGraFie: {
            defaultValue: 'Pro'
        },
        desLocFie: {
            visible: _.get(submissionVM, 'lobData.spaAndWellLine.selectedOffering_Ext.value') === heaWelFitFac
        },
        occFie: {
            defaultValue: 'Commercial'
        }
    };


    const deleteinformation = useCallback(
        () => {
            const infoListPath = 'lobData.spaAndWellLine.coverables.locRisks.value';
            const info = modelVM.value;
            const infoList = _.get(submissionVM, infoListPath);

            showConfirm({
                title: messages.removeInfoSW,
                message: messages.removeInfoDescSW,
                status: 'warning',
                icon: 'mi-error-outline',
                confirmButtonText: messages.yes,
                cancelButtonText: messages.no
            }).then(
                (results) => {
                    if (results === 'cancel') {
                        return _.noop();
                    }

                    const newinfoList = _.remove(infoList,
                        (infoFromList) => _.isEqual(infoFromList, info));

                    _.set(submissionVM, newinfoList, infoListPath);
                    updateWizardData(submissionVM);

                    return true;
                }, _.noop
            );
        }, [modelVM.value, submissionVM, showConfirm, updateWizardData]
    );


    const resolvers = {
        resolveCallbackMap: {
            deleteinformation,
            onValidate,
            setIsEditButton,
            setIsCancelButton,
            setIsSaveButton
        },
        resolveComponentMap: {
            coveragespagecomponent: CoveragesPageComponent,
            AddressComponent
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            // onModelChange={updateWizardData}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

InformationComponent.propTypes = wizardProps;
export default withRouter(InformationComponent);
